import { useTranslation } from 'next-i18next';
import { lazyHydrate } from 'next-lazy-hydration-on-scroll';

import HeroContentSection from './HeroContentSection';
import PartnersSection from 'components/landing/PartnersSection';
const CompaniesSection = lazyHydrate(() => import('./CompaniesSection'));
const SeafarersSection = lazyHydrate(() => import('./SeafarersSection'));
const JobListSection   = lazyHydrate(() => import('./JobListSection'));
const TestimonialSection = lazyHydrate(() => import('components/landing/TestimonialSection'));
const FaqSection = lazyHydrate(() => import('components/landing/FaqSection'));
const FooterCtaMobileApp = lazyHydrate(() => import('components/landing/FooterCtaMobileApp'));

import LogoVallianz from 'public/images/logo/clients/logo-vallianz.png';
import LogoIcon from 'public/images/landing/partners/partner-logo-21.webp';
import LogoSusi from 'public/images/landing/partners/partner-logo-27.webp';

const Home = () => {
  const { t } = useTranslation(['home', 'common']);

  const testimonialData = [
    {
      type: 'company',
      contentType: t('MaritimeCompany', { ns: 'common' }),
      contentName: 'Vallianz Offshore',
      contentDetail: 'Aplikasi ini sangat bagus! Mempermudah para pelaut dalam menemukan pekerjaan yang sesuai dengan posisinya. Untuk perusahaan, OnBoard memiliki fitur profil match sehingga bisa mempermudah dalam mensortir kandidat, dan ada tahapan rekrutmen yang dapat disesuaikan dengan kebutuhan perusahaan.',
      contentImageSrc: LogoVallianz.src,
      contentImageBlurDataURL: LogoVallianz.blurDataURL,
    },
    {
      type: 'seafarer',
      contentType: t('Seafarer', { ns: 'common' }),
      contentName: 'Yudi Purnomo',
      contentDetail: 'Aplikasi yg sangat membantu dalam mencari dan melamar pekerjaan dibidang pelayaran.',
      contentImageSrc: LogoVallianz.src,
      contentImageBlurDataURL: LogoVallianz.blurDataURL,
    },
    {
      type: 'seafarer',
      contentType: t('Seafarer', { ns: 'common' }),
      contentName: 'Ayub Ansori',
      contentDetail: 'This app is very helpful. After I applied to one of the companies, I was immediately called for an interview shortly afterward. Thank you!',
      contentImageSrc: LogoVallianz.src,
      contentImageBlurDataURL: LogoVallianz.blurDataURL,
    },
    {
      type: 'company',
      contentType: t('MaritimeCompany', { ns: 'common' }),
      contentName: 'Indo Container Line',
      contentDetail: 'Aplikasi OnBoard, sangat membantu kami sebagai recruiter, mempersingkat waktu dalam screening CV menentukan candidat yang cocok dengan kualifikasi perusahaan.',
      contentImageSrc: LogoIcon.src,
      contentImageBlurDataURL: LogoIcon.blurDataURL,
    },
    {
      type: 'seafarer',
      contentType: t('Seafarer', { ns: 'common' }),
      contentName: 'Robby Kalensang',
      contentDetail: 'Aplikasi sangat membantu buat para pelaut yg lagi butuh jobs.',
      contentImageSrc: LogoVallianz.src,
      contentImageBlurDataURL: LogoVallianz.blurDataURL,
    },
    {
      type: 'seafarer',
      contentType: t('Seafarer', { ns: 'common' }),
      contentName: 'Agus efendi',
      contentDetail: 'Terima kasih OnBoard menerima saya sebagai patner kerja. Semoga dimudahkan segalanya. Maju terus dan jaya, OnBoard selamanya!',
      contentImageSrc: LogoVallianz.src,
      contentImageBlurDataURL: LogoVallianz.blurDataURL,
    },
    {
      type: 'company',
      contentType: t('MaritimeCompany', { ns: 'common' }),
      contentName: 'Segara Sakti Sejati',
      contentDetail: 'Saya sangat puas dengan platform OnBoard sejauh ini. Fitur-fitur yang disediakan sangat membantu dalam proses onboarding, dan tim supportnya sangat responsif. Proses menjadi lebih efisien dan mudah!',
      contentImageSrc: LogoSusi.src,
      contentImageBlurDataURL: LogoSusi.blurDataURL,
    },
    {
      type: 'seafarer',
      contentType: t('Seafarer', { ns: 'common' }),
      contentName: 'Muhammad Mursal Siregar',
      contentDetail: 'Sangat bagus! Semoga makin banyak bekerjasama dengan perusahaan perusahaan ternama.',
      contentImageSrc: LogoVallianz.src,
      contentImageBlurDataURL: LogoVallianz.blurDataURL,
    },
  ];

  return (
    <>
      <HeroContentSection />
      <PartnersSection />
      <CompaniesSection />
      <SeafarersSection />
      <JobListSection />
      <TestimonialSection testimonialData={testimonialData} />
      <FaqSection />

      <FooterCtaMobileApp />
    </>
  );
};

export default Home;
